export default __webpack_public_path__ + "img/img_vin_kumar-a4ee4b7ebc4e99bb800760f73f2bb3e8.jpg";